import { createFeatureSelector, createSelector } from '@ngrx/store'
import { OfflineTrackerState } from '../state/offline-tracker.state'

const getState = createFeatureSelector<OfflineTrackerState>('offlineTracker')

export const getDetails = () =>
  createSelector(getState, state => {
    return state?.details
  })

export const getSummaryList = () =>
  createSelector(getState, state => {
    return state?.summary
  })
